"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortGolfData = void 0;
const sortGolfData = (golfData, sortingData) => {
    // Filter out null values from the golf data
    const filteredGolfData = golfData.filter((item) => item !== null && item !== undefined);
    // Create a lookup dictionary for the sorting data based on the course ID
    const sortingLookup = sortingData.reduce((lookup, item) => {
        lookup[item.course_id] = item;
        return lookup;
    }, {});
    // Sort the golf data based on the sorting data
    const sortedGolfData = filteredGolfData.length > 0 && sortingData.length > 0
        ? filteredGolfData.sort((a, b) => {
            const course_a_id = a.config?.course.id;
            const course_b_id = b.config?.course.id;
            const dateA = course_a_id ? sortingLookup[course_a_id]?.date || 0 : 0;
            const dateB = course_b_id ? sortingLookup[course_b_id]?.date || 0 : 0;
            return dateA?.localeCompare(dateB) || 0;
        })
        : filteredGolfData;
    // Reintroduce null values in the original positions
    const sortedGolfDataWithNulls = golfData.map((item) => {
        if (item === null) {
            return null;
        }
        else {
            return sortedGolfData.shift();
        }
    });
    return sortedGolfDataWithNulls;
};
exports.sortGolfData = sortGolfData;
